import React from 'react';
import PropTypes from 'prop-types';

import Avatar from '@decisiv/ui-components/lib/components/Avatar';
import Message from '@decisiv/ui-components/lib/components/Message';
import { P } from '@decisiv/ui-components/lib/components/Typography';

import StepHeader from './StepHeader';
import { EXISTING_USER } from './copy';
import {
  AcknowledgmentIdentity,
  ExistingUserIdentityText,
  StepBody,
} from './styles';

function AcknowledgmentPanel({ existingUser }) {
  const copy = EXISTING_USER.acknowledge;

  return (
    <StepBody>
      <StepHeader subtitle={copy.body} title={copy.title} />

      <AcknowledgmentIdentity>
        <Avatar email={existingUser.email} name={existingUser.fullName} />
        <ExistingUserIdentityText>
          <P weight="semibold" style={{ margin: 0 }}>
            {existingUser.fullName}
            {existingUser.jobRole ? ` (${existingUser.jobRole})` : ''}
          </P>
          <P shade={1} size="small" style={{ margin: 0 }}>
            {existingUser.email}
          </P>
        </ExistingUserIdentityText>
      </AcknowledgmentIdentity>

      <Message intent="information">{copy.note}</Message>
    </StepBody>
  );
}

AcknowledgmentPanel.propTypes = {
  existingUser: PropTypes.shape({
    addAccountIds: PropTypes.arrayOf(PropTypes.number),
    email: PropTypes.string,
    fullName: PropTypes.string,
    jobRole: PropTypes.string,
    restoreAccountIds: PropTypes.arrayOf(PropTypes.number),
  }).isRequired,
};

export default AcknowledgmentPanel;
